export default __webpack_public_path__ + "static/media/General_01.f0524371.webp";